module.exports = __webpack_public_path__ + "img/pin-in-3.3dd37abf.svg";